import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { PWAProvider } from "@/context/PWAContext";
import Dashboard from "@/pages/Dashboard";
import ModelsList from "@/pages/models-list";
import PreviewsList from "@/pages/previews-list";
import Login from "@/pages/Login";
import ProtectedRoute from "@/context/ProtectedRoute";
import Preview from "@/pages/preview-view";
import Layout from "@/pages/Layout";
import { SonnerProvider } from "@/components/ui/sonner-provider";
import ProfilePage from "./pages/profile-page";
import SharedViewerPage from "@/pages/shared/SharedPreview";
import ProjectsPage from "@/pages/projects-page";
import ProjectDetailPage from "@/pages/project-detail-page";
import Home from "./components/Home/home";
function App() {
    return (
        <PWAProvider>
            <AuthProvider>
                <ThemeProvider>
                    <Router>
                        <SonnerProvider />
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/" element={<Home />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Layout>
                                            <Dashboard />
                                        </Layout>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/models"
                                element={
                                    <ProtectedRoute>
                                        <Layout>
                                            <ModelsList />
                                        </Layout>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/projects"
                                element={
                                    <ProtectedRoute>
                                        <Layout>
                                            <ProjectsPage />
                                        </Layout>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/projects/:projectId"
                                element={
                                    <ProtectedRoute>
                                        <Layout>
                                            <ProjectDetailPage />
                                        </Layout>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/previews"
                                element={
                                    <ProtectedRoute>
                                        <Layout>
                                            <PreviewsList />
                                        </Layout>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/viewer/:id"
                                element={
                                    <ProtectedRoute>
                                        <Layout>
                                            <Preview />
                                        </Layout>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/profile"
                                element={
                                    <ProtectedRoute>
                                        <Layout>
                                            <ProfilePage />
                                        </Layout>
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/shared/:id"
                                element={
                                    <SharedViewerPage />
                                }
                            />                
                            {/* Add more routes as needed */}
                        </Routes>
                    </Router>
                </ThemeProvider>
            </AuthProvider>
        </PWAProvider>
    );
}

export default App;